import dayjs from "dayjs";
import { createSlice } from "@reduxjs/toolkit";


export const calendarSlice = createSlice({
  name: 'calendar',
  initialState: {
    dayDate: dayjs(),
    weekDate: dayjs(),
    monthDate: dayjs(),
    quarterYearDate: dayjs(),
    halfYearDate: dayjs(),
    yearDate: dayjs(),
    layout: 2,
    // The month the calendar is anchored at: it opens there after a reload, and the bar's 1, 3, 6 and 12 buttons
    // open from it. null follows today. The profile keeps it as its custom first month.
    anchor: null,
    // The year the bar's year button opens.
    viewYear: dayjs().year(),
    // Ctrl / Cmd is held: events can be rearranged within their day.
    gridDragMode: false,
    // The day ('YYYY-MM-DD') under the pointer while Ctrl / Cmd is held. Only that day's events are draggable.
    gridDragDay: null,
  },
  reducers: {
    setDayDate: (state, action) => {
      state.dayDate = action.payload;
    },
    setWeekDate: (state, action) => {
      state.weekDate = action.payload;
    },
    setMonthDate: (state, action) => {
      state.monthDate = action.payload;
    },
    setQuarterYearDate: (state, action) => {
      state.quarterYearDate = action.payload;
    },
    setHalfYearDate: (state, action) => {
      state.halfYearDate = action.payload;
    },
    setYearDate: (state, action) => {
      state.yearDate = action.payload;
    },
    setLayout: (state, action) => {
      state.layout = action.payload;
    },
    setAnchor: (state, action) => {
      state.anchor = action.payload;
    },
    setViewYear: (state, action) => {
      state.viewYear = action.payload;
    },
    setGridDragMode: (state, action) => {
      state.gridDragMode = action.payload;
      if (!action.payload) state.gridDragDay = null;
    },
    setGridDragDay: (state, action) => {
      state.gridDragDay = action.payload;
    },
    setAllDates: (state, action) => {
      const { dayDate, weekDate, monthDate, quarterYearDate, halfYearDate, yearDate } = action.payload;
      if (dayDate !== undefined) state.dayDate = dayDate;
      if (weekDate !== undefined) state.weekDate = weekDate;
      if (monthDate !== undefined) state.monthDate = monthDate;
      if (quarterYearDate !== undefined) state.quarterYearDate = quarterYearDate;
      if (halfYearDate !== undefined) state.halfYearDate = halfYearDate;
      if (yearDate !== undefined) state.yearDate = yearDate;
    }
  },
});

export const { setDayDate, setWeekDate, setMonthDate, setHalfYearDate, setQuarterYearDate, setYearDate, setLayout, setAllDates, setGridDragMode, setGridDragDay, setAnchor, setViewYear } = calendarSlice.actions;

export default calendarSlice.reducer;